import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import smoothscroll from "smoothscroll-polyfill";
import { initI18N } from "i18n";
import { initTailwindTheme } from "shared-utils";
import { Spinner } from "component-library";
import TagManager from "react-gtm-module";

import { Root } from "app/app-shell/Root/Root";

import { config } from "config";
import "./index.css";
import "./app/App.scss";

initTailwindTheme();

TagManager.initialize({
  gtmId: config.gtm.gtmId,
  dataLayerName: config.gtm.dataLayerName,
});

smoothscroll.polyfill();

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

initI18N(["performer"])
  .then(() => {
    root.render(
      <Suspense fallback={<Spinner />}>
        <Root />
      </Suspense>
    );
  })
  .catch((error) => {
    console.error(error);
  });
